import { useEffect, useState } from "react";
import { API_BASE } from "@/lib/apiClient";

function buildFetchUrl(path: string): string {
  if (/^https?:\/\//i.test(path)) return path;
  if (!API_BASE) return path;
  return `${API_BASE}${path.startsWith("/") ? "" : "/"}${path}`;
}

/**
 * Profilfoto wie in der klassischen App: /me/photo, danach lokaler Avatarkatalog.
 */
export function useUserPhoto(login: string, email: string | null | undefined): string | null {
  const [photoUrl, setPhotoUrl] = useState<string | null>(null);

  useEffect(() => {
    let objectUrl: string | null = null;
    let cancelled = false;

    const candidates = [
      buildFetchUrl("/me/photo"),
      login ? `/static/avatars/${encodeURIComponent(login)}.jpg` : null,
      email ? `/static/avatars/${encodeURIComponent(email)}.jpg` : null,
    ].filter((url): url is string => Boolean(url));

    void (async () => {
      for (const url of candidates) {
        try {
          const res = await fetch(url, { credentials: "include", cache: "no-store" });
          const ctype = res.headers.get("content-type") || "";
          if (!res.ok || !ctype.startsWith("image/")) continue;
          const blob = await res.blob();
          if (cancelled) return;
          objectUrl = URL.createObjectURL(blob);
          setPhotoUrl(objectUrl);
          return;
        } catch {
          // nächste Quelle
        }
      }
      if (!cancelled) setPhotoUrl(null);
    })();

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [login, email]);

  return photoUrl;
}
